function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".user-1{fill:#16224a;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Users"
}, /*#__PURE__*/React.createElement("path", {
  className: "user-1",
  d: "M43.13,29.61a2.44,2.44,0,0,1-.69-4l.39-.39A14.93,14.93,0,0,0,29.19.27,14.58,14.58,0,0,0,17.41,11.71a15,15,0,0,0,4.11,13.87,2.5,2.5,0,0,1,.79,1.8h0a2.39,2.39,0,0,1-1.45,2.23A24.58,24.58,0,0,0,7.64,42.72,31.34,31.34,0,0,0,5,55.6v3.19A5.21,5.21,0,0,0,10.25,64h43.5A5.21,5.21,0,0,0,59,58.79V55.57a31.35,31.35,0,0,0-2.61-12.88A24.58,24.58,0,0,0,43.13,29.61Z",
  transform: "translate(-5.04)"
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "User_1",
    "data-name": "Users 1",
    viewBox: "0 0 53.93 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/User.071f75f8.svg";
export { ForwardRef as ReactComponent };